<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
    <v-flex pa-1 md9 sm10 xs12>
      <v-card>
        <v-card-text>
          <h1><i>RSVP</i></h1>
          <br>
          <h4>Thank you for your reply!</h4>
          <br>
          <br>
          <br>
          <br>
          <h5>
              If you changed your mind prior to the wedding, please reach out to Dan McDade
              <br>
              becase he didn't finish building that part of the website.
          </h5>
          <br>
          <br>
          <contact-cards></contact-cards>
        </v-card-text>
      </v-card>
    </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ContactCards from '@/components/ContactCards.vue';

export default {
  name: 'ReplyMessage',
  components: {
    ContactCards,
  },
  data() {
    return {
      info: 'My Message',
    };
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
  font: 5rem sans-serif;
}
h3 {
  text-align: center;
  font: 3rem sans-serif;
}
h4 {
  text-align: center;
  font: 2rem sans-serif;
}
h5 {
  text-align: center;
  font: 1.4rem sans-serif;
}
h6 {
  text-align: center;
  font: 1rem sans-serif;
}
</style>
